import { Component, inject, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { HomepageService } from '@features/home/data-access/homepage.service';
import { LocalizationStore } from '@core/localization';
import { SkinningService } from '@core/skin';
import { CardPreauthToastComponent } from '@core/card-preauth';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent, CardPreauthToastComponent],
  template: `
    @if (skinning.initialized) {
      <div class="app-wrapper flex flex-col" [ngClass]="{'mobile-vebview': isMobile}">
        @if (displayHeader && localizations.ready()) {
          <header
            [items]="homepageService.menuItems()"
            (goHomeClicked)="goHomeClicked.emit()"
            [minimalHeader]="minimalHeader"
            (searchOpened)="searchOpened.emit($event)"
            [isMobile]="isMobile">
          </header>
        }
        <div class="content">
          <router-outlet></router-outlet>
        </div>
        <ng-content select="details-shell"></ng-content>
        <ng-content select="asset-search"></ng-content>
        @if (displayHeader && !programme) {
          <footer></footer>
        }
        @if (displayHeader) {
          <card-preauth-toast></card-preauth-toast>
        }
      </div>
    }
    `,
  styles: [`
    .app-wrapper {
      min-height: 100vh;
    }
    .content {
      flex: 1;
    }
  `]
})
export class MainLayoutComponent {
  public homepageService = inject(HomepageService);
  public localizations = inject(LocalizationStore);
  public skinning = inject(SkinningService);

  @Input() isMobile: boolean = false;
  @Input() displayHeader: boolean = true;
  @Input() minimalHeader: boolean = false;
  @Input() programme: boolean = false;
  
  @Output() goHomeClicked = new EventEmitter<void>();
  @Output() searchOpened = new EventEmitter<boolean>();
}
